import _defineProperty from '@babel/runtime/helpers/defineProperty';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { PropTypes as PropTypes$1 } from '@panneau/core';
import { isMessage } from '@panneau/core/utils';
import Button from '@panneau/element-button';
import Buttons from '@panneau/element-buttons';
import Label from '@panneau/element-label';
import Modal from '@panneau/element-modal';

var styles = {"container":"panneau-modal-dialog-container","closeOutside":"panneau-modal-dialog-closeOutside","closeOutsideButton":"panneau-modal-dialog-closeOutsideButton"};

var propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  title: PropTypes$1.label,
  size: PropTypes.string,
  header: PropTypes.node,
  children: PropTypes.node,
  footer: PropTypes.node,
  buttons: PropTypes$1.buttons,
  onClose: PropTypes.func,
  withCloseOutside: PropTypes.bool,
  className: PropTypes.string
};
var defaultProps = {
  title: null,
  size: null,
  header: null,
  children: null,
  footer: null,
  buttons: null,
  onClose: null,
  withCloseOutside: false,
  className: null
};
var ModalDialog = function ModalDialog(_ref) {
  var id = _ref.id,
    title = _ref.title,
    size = _ref.size,
    header = _ref.header,
    children = _ref.children,
    buttons = _ref.buttons,
    footer = _ref.footer,
    onClose = _ref.onClose,
    withCloseOutside = _ref.withCloseOutside,
    className = _ref.className;
  var onCloseButtonOutside = header === null && title === null && onClose !== null || withCloseOutside && onClose !== null;
  return /*#__PURE__*/React.createElement(Modal, {
    id: id,
    onClose: onClose
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(['modal-dialog', styles.container, _defineProperty(_defineProperty(_defineProperty({}, "modal-".concat(size), size !== null), styles.closeOutside, onCloseButtonOutside), className, className)]),
    role: "dialog"
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal-content"
  }, onCloseButtonOutside ? /*#__PURE__*/React.createElement(Button, {
    type: "button",
    className: classNames([styles.closeOutsideButton, 'btn', 'btn-close', 'bg-light',
    // 'btn-close-white',
    'btn-secondary', 'p-2']),
    "aria-label": "Close",
    onClick: onClose
  }) : null, header !== null ? header : /*#__PURE__*/React.createElement("div", {
    className: classNames([{
      'modal-header': title !== null
    }])
  }, title !== null ? /*#__PURE__*/React.createElement("h5", {
    className: "modal-title pe-2"
  }, isMessage ? /*#__PURE__*/React.createElement(Label, null, title) : title) : null, title !== null && onClose !== null ? /*#__PURE__*/React.createElement(Button, {
    type: "button",
    className: classNames(['btn-close', 'close']),
    "aria-label": "Close",
    onClick: onClose
  }) : null), /*#__PURE__*/React.createElement("div", {
    className: classNames(['modal-body', styles.body])
  }, children), footer !== null || buttons !== null ? /*#__PURE__*/React.createElement("div", {
    className: classNames(['modal-footer', styles.footer])
  }, footer !== null ? footer : null, buttons !== null ? /*#__PURE__*/React.createElement(Buttons, {
    items: buttons,
    className: styles.buttons
  }) : null) : null)));
};
ModalDialog.propTypes = propTypes;
ModalDialog.defaultProps = defaultProps;

export { ModalDialog as default };
